import { useState, useEffect, useRef } from "react";
import { useTheme } from "styled-components";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import lobbyImg from "../assets/img/lobby.svg";
import lobbyBoldImg from "../assets/img/lobbyBold.svg";
import docsImg from "../assets/img/docs.svg";
import docsBoldImg from "../assets/img/docsBold.svg";
import notificationImg from "../assets/img/notification.svg";
import notificationBoldImg from "../assets/img/notificationBold.svg";
import accountImg from "../assets/img/account.svg";
import accountBoldImg from "../assets/img/accountBold.svg";
import appliesBoldImg from "../assets/img/appliesBold.svg";
import appliesImg from "../assets/img/applies.svg";
import contactsImg from "../assets/img/contacts.svg";
import addSquareImg from "../assets/img/add-square.svg";
import contactsBoldImg from "../assets/img/contactsBold.svg";
import buildingBoldImg from "../assets/img/buildingBold.svg";
import buildingImg from "../assets/img/building-4.svg";
import buildingRegImg from "../assets/img/building.svg";
import { Text } from "../UI";
import {
  TextSpeech as DepartmentsMenu,
  ListItem,
  List,
  ScrollDiv,
} from "../components/Common";
import { Role } from "../stores/userStore";
import MenuItem from "./MenuItem";
import NewApply from "./NewApply";

const drawerWidth = 90;

const SideBar = ({ userStore, tenantsStore, departments, ...props }) => {
  let location = useLocation().pathname;
  const theme = useTheme();
  const { i18n } = useTranslation("menu");
  const [showDepratmentsMenu, setShowDepratmentsMenu] = useState(false);
  const depMenu = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (depMenu.current && !depMenu.current.contains(event.target)) {
        setShowDepratmentsMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depMenu]);

  const navigate = useNavigate();
  return (
    <div>
      <div
        style={{
          position: "fixed",
          height: "100%",
          width: drawerWidth,
          backgroundColor: `rgba(246, 250, 253, 0.9)`,
          zIndex: 999,
          top: 0,
          right: i18n.dir() === "rtl" ? 0 : "",
          left: i18n.dir() === "ltr" ? 0 : "",
        }}>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            width: drawerWidth,
            height: 84,
            margin: 0,
            display: "flex",
            justifyContent: "center",
            backgroundImage: `url('${props.logo}')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center center",
          }}></div>
        <div>
          <ScrollDiv maxHeight={"90vh"} style={{ height: "90vh" }}>
            {props.admin ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "inherit",
                  gap: 10,
                  paddingBlockStart: 29,
                  paddingBlockEnd: 14,
                }}>
                <MenuItem
                  setTitle={props.setTitle}
                  img={
                    location.includes("projects")
                      ? buildingBoldImg
                      : buildingImg
                  }
                  title="projects"
                  selected={
                    location.includes("projects") ||
                    location.includes("tenants")
                  }
                  navigateTo={"/admin/projects"}
                  isAdmin={userStore.userDetails.role === Role.Admin}
                />
              </div>
            ) : props.bedek ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "inherit",
                  gap: 10,
                  paddingBlockStart: 29,
                  paddingBlockEnd: 14,
                }}>
                {userStore.userDetails.role === Role.Admin && (
                  <MenuItem
                    setTitle={props.setTitle}
                    img={buildingRegImg}
                    title="projects"
                    selected={
                      location.includes("projects") ||
                      location.includes("tenants")
                    }
                    navigateTo={"/admin/projects"}
                    isAdmin={userStore.userDetails.role === Role.Admin}
                  />
                )}
                <MenuItem
                  setTitle={props.setTitle}
                  img={appliesImg}
                  title="applies"
                  selected={location.includes("applies")}
                  navigateTo={"/bedek/applies"}
                  isAdmin={true}
                />
                <NewApply
                  backgroundColor={theme.color.green}
                  style={{
                    flex: 1,
                    justifyContent: "end",
                    alignSelf: "center",
                  }}
                  setTitle={props.setTitle}
                  img={addSquareImg}
                  title="add_apply"
                  onItemClicked={() => {
                    setShowDepratmentsMenu(!showDepratmentsMenu);
                  }}
                />
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "inherit",
                  gap: 14,
                  paddingBlockStart: 29,
                  paddingBlockEnd: 14,
                }}>
                {userStore.userDetails.role === Role.Admin && (
                  <MenuItem
                    setTitle={props.setTitle}
                    img={buildingRegImg}
                    title="projects"
                    selected={
                      location.includes("projects") ||
                      location.includes("tenants")
                    }
                    navigateTo={"/admin/projects"}
                    isAdmin={true}
                  />
                )}
                <MenuItem
                  setTitle={props.setTitle}
                  img={location.includes("lobby") ? lobbyBoldImg : lobbyImg}
                  title="lobby"
                  selected={location.includes("lobby")}
                  navigateTo={"/tenant/lobby"}
                />
                <MenuItem
                  setTitle={props.setTitle}
                  img={location.includes("docs") ? docsBoldImg : docsImg}
                  title="docs"
                  selected={location.includes("docs")}
                  navigateTo={"/tenant/docs"}
                />
                <MenuItem
                  setTitle={props.setTitle}
                  img={
                    location.includes("account") ? accountBoldImg : accountImg
                  }
                  title="account"
                  selected={location.includes("account")}
                  navigateTo={"/tenant/account"}
                />
                {departments.length > 0 && (
                  <MenuItem
                    setTitle={props.setTitle}
                    img={
                      location.includes("applies") ? appliesBoldImg : appliesImg
                    }
                    title="applies"
                    selected={location.includes("applies")}
                    navigateTo={"/tenant/applies"}
                  />
                )}
                <MenuItem
                  setTitle={props.setTitle}
                  img={
                    location.includes("messages")
                      ? notificationBoldImg
                      : notificationImg
                  }
                  title="messages"
                  selected={location.includes("messages")}
                  navigateTo={"/tenant/messages"}
                />
                <MenuItem
                  setTitle={props.setTitle}
                  img={
                    location.includes("contacts")
                      ? contactsBoldImg
                      : contactsImg
                  }
                  title="contacts"
                  selected={location.includes("contacts")}
                  navigateTo={"/tenant/contacts"}
                />
                {departments.length > 0 && (
                  <NewApply
                    backgroundColor={theme.color.green}
                    style={{
                      flex: 1,
                      alignSelf: "center",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                    setTitle={props.setTitle}
                    img={addSquareImg}
                    title="add_apply"
                    onItemClicked={() => {
                      setShowDepratmentsMenu(!showDepratmentsMenu);
                    }}
                  />
                )}
              </div>
            )}
          </ScrollDiv>
        </div>
        {showDepratmentsMenu && (
          <DepartmentsMenu
            ref={depMenu}
            positionFromTop={"80%"}
            backgroundColor={theme.color.white}
            style={{
              marginRight: "100px",
              width: 220,
              borderRadius: 18,
              position: "absolute",
              bottom: 0,
              boxShadow: `0px 4px 20px #C3C0D3`,
            }}>
            <List style={{ flexDirection: "column", gap: 5 }}>
              {departments.map((department, index) => (
                <ListItem
                  key={index}
                  onClick={() => {
                    if (department.BEDEKFLAG === "Y") {
                      if (props.bedek) {
                        navigate("/bedek/new-repair-page", {
                          state: {
                            department: department.DEPARTDES,
                            bedek: true,
                          },
                        });
                      } else {
                        navigate("/tenant/new-repair-page", {
                          state: {
                            department: department.DEPARTDES,
                            user: department.USERLOGIN,
                          },
                        });
                      }
                    } else {
                      navigate("/tenant/new-apply", {
                        state: {
                          department: department.DEPARTDES,
                          user: department.USERLOGIN,
                          type: department.CUSTNOTETYPEDES,
                        },
                      });
                    }
                    setShowDepratmentsMenu(!showDepratmentsMenu);
                  }}
                  style={{
                    width: "auto",
                    height: "auto",
                    cursor: "pointer",
                  }}>
                  <Text.BB
                    key={index}
                    color={theme.color.gray90}
                    style={{ cursor: "pointer" }}>
                    {department.DEPARTDES}
                  </Text.BB>
                </ListItem>
              ))}
            </List>
          </DepartmentsMenu>
        )}
      </div>
      <div style={{ marginInlineStart: drawerWidth }}>{props.children}</div>
    </div>
  );
};
export default inject("userStore", "tenantsStore")(observer(SideBar));
